(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gdc-tokens"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__gdcRevealInit) return;
  window.__gdcRevealInit = true;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) {
        setTimeout(function () { e.target.classList.add('gdc-visible'); }, i * 80);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.05 });
  function observe() {
    document.querySelectorAll('.gdc-fade').forEach(function (el) { obs.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
